import { useFormik } from "formik";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from "react-dropdown-select";

interface LinkNewCategoryWithPageUrlModalFormProps {
  onLinkNewCategory: (payload: any) => void;
  categoryListForDropdown: {
    categoryName: string;
    categoryId: number;
  }[];
}

const LinkNewCategoryWithPageUrlModalForm: React.FC<
  LinkNewCategoryWithPageUrlModalFormProps
> = ({ onLinkNewCategory, categoryListForDropdown }) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      categoryId: null,
    },
    onSubmit: (values, { resetForm }) => {
      onLinkNewCategory(values);
      resetForm();
      handleModalClose();
    },
  });

  return (
    <>
      {
        <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
          Link New Category
        </Button>
      }
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{"Add New Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="findState">
              <Form.Label>Category</Form.Label>
              <Select
                options={categoryListForDropdown}
                labelField="categoryName"
                valueField="categoryId"
                searchable
                searchBy={"categoryName"}
                required={true}
                onChange={(values) =>
                  formik.setFieldValue("categoryId", values[0]?.categoryId)
                }
                values={[]}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {"Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LinkNewCategoryWithPageUrlModalForm;
